import { useEffect, useState } from 'react';
import { PATHURLDOMAIN } from '../constantes/constantes';

const THEME_URL =  PATHURLDOMAIN + 'json/theme_templates.json';

/**
 * Hook que consume el JSON de theme_templates y expone
 * las secciones: header, navigation, footer, social, script.
 */
export function useThemeTemplates() {
  const [theme, setTheme] = useState({
    header: '',
    navigation: '',
    footer: '',
    social: '',
    script: '',
    css: '',
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const controller = new AbortController();

    async function fetchTheme() {
      try {
        // Reutiliza la promesa iniciada en index.html (descarga temprana).
        // Si no existe, hace el fetch como respaldo.
        const data = window.__themeTemplatesPromise
          ? await window.__themeTemplatesPromise
          : await (async () => {
              const response = await fetch(THEME_URL, {
                signal: controller.signal,
              });

              if (!response.ok) {
                throw new Error(`Error al cargar theme_templates: ${response.status}`);
              }

              return response.json();
            })();

        setTheme({
          header: data.header || '',
          navigation: data.navigation || '',
          footer: data.footer || '',
          social: data.social || '',
          script: data.script || '',
          css: data.css || '',
        });
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.error('[useThemeTemplates]', error.message);
        }
      } finally {
        setLoading(false);
      }
    }

    fetchTheme();

    return () => controller.abort();
  }, []);

  return { theme, loading };
}
